import Builder from "./SearchBuilder";
import SearchStorage from "./SearchStorage";
import ApiClient from "redbay-b2b-api/src/ApiClient";

export default {
  namespaced: true,
  state: {
    loadedFromStorage: false,
    phrase: "",
    phraseType: "",
    attributes: [],
    categoryList: [],
    producerList: [],
    page: {
      current: 1,
      limit: 40
    },
    selectedSort: "nameAsc",
    reload: 0,
    available: false,
    builtFilters: [],
    kindList: "",
    groups: [],
    department: 0
  },

  mutations: {},

  actions: {
    async requestData({ commit, state }, filters) {
      if (!state.loadedFromStorage) {
        state.attributes = SearchStorage.loadParams("attributes");
        state.categoryList = SearchStorage.loadParams("categories");
        state.producerList = SearchStorage.loadParams("producers");
        state.page = SearchStorage.loadPage();
        state.selectedSort = SearchStorage.loadSort();
        // state.selectedSort = SearchStorage.loadSort(state.producerList);
        state.phrase = SearchStorage.loadPhrase();
        state.phraseType = SearchStorage.loadPhraseType();
        state.loadedFromStorage = true;
      }

      let builder = new Builder();
      builder.addPage(state.page.current, state.page.limit);
      builder.addActiveProducers();
      builder.addPhrase(state.phrase, state.phraseType);
      builder.addCategoryIds(state.categoryList.map(c => c.id));
      builder.addProducers(state.producerList);
      builder.addAttributes(state.attributes);
      builder.addSort(state.selectedSort, state.producerList);
      builder.addAggregationsProducer(150);
      builder.addAggregationsCategory(300);
      if (state.available) {
        builder.addOnlyAvailableProducts(state.department);
      }
      state.groups.forEach(group => builder.addGroupName(group));

      filters.attributes.forEach(a =>
        builder.addAggregationAttribute(a.name, a.name, a.limit)
      );

      SearchStorage.saveParams(
        state.phrase,
        state.phraseType,
        state.attributes,
        state.categoryList,
        state.producerList,
        state.page,
        state.selectedSort
      );

      return await ApiClient.post("products/search", builder.build());
    },

    clear({ commit, state }) {
      state.loadedFromStorage = true;
      state.phrase = "";
      state.phraseType = "";
      state.attributes = [];
      state.categoryList = [];
      state.producerList = [];
      state.page = {
        current: 1,
        limit: 40
      };
    },

    selectedProducer({ commit, state }, producers) {
      state.producerList = producers;
      state.reload++;
    },

    selectedProducerClear({ commit, state }, producers) {
      this.dispatch("search/clear");
      state.producerList = producers;
      state.reload++;
    },

    selectedCategoryClear({ commit, state }, category) {
      this.dispatch("search/clear");
      state.categoryList = [category];
      state.reload++;
    },

    selectedCategory({ commit, state }, category) {
      state.categoryList = [category];
      state.reload++;
    },

    findByPhrase({ commit, state }) {
      let phrase = state.phrase;
      this.dispatch("search/clear");
      state.phrase = phrase;
      state.reload++;
    },

    findByPhraseCondition({ state }, params) {
      this.dispatch("search/clear");
      state.phrase = params.phrase;
      state.phraseType = params.type;
      state.reload++;
    },

    async autocomplete({ commit, state }, phrase) {
      return {
        data: []
      };
      return await ApiClient.get("api/autocomplete?text=" + phrase);
    },

    async findProduct({ commit, state }, params) {
      let builder = new Builder();
      builder.addProductId(params.id);
      builder.addPage(1, 1);
      builder.addAttributes(state.attributes);
      builder.addAggregationsProducer(150);
      builder.addAggregationsCategory(300);
      state.groups.forEach(group => builder.addGroupName(group));
      params.filters.attributes.forEach(a =>
        builder.addAggregationAttribute(a.name, a.name, a.limit)
      );
      return await ApiClient.post("products/search", builder.build());
    },

    async description({}, productId) {
      return await ApiClient.get("api/product/" + productId + "/description");
    },

    async shortDescription({}, productId) {
      return await ApiClient.get(
        "api/product/" + productId + "/shortdescription"
      );
    },

    async getGroups() {
      return await ApiClient.get("api/shop/groups");
    },

    reload({ state }) {
      state.reload++;
    },

    setBuiltFilters({ state }, filters) {
      state.builtFilters = filters;
    },

    setKindList({ state }, type) {
      state.kindList = type;
    },

    loadKindList({ state }) {
      state.kindList = SearchStorage.loadKindList();
    },

    setDepartment({ state }, id) {
      state.department = id;
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/products/src/search/SearchStore.js